import { useMemo } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { ButtonChipItem, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import type { ICampaignCompetitor } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

const ChipWrapper = styled.div`
    ${SWReactIcons} {
        width: 24px;
        height: 24px;
    }
`;

interface ICompetitorsIndicatorProps {
    competitors: ICampaignCompetitor[];
}

export const CompetitorsIndicator = ({ competitors = [] }: ICompetitorsIndicatorProps) => {
    const domainsList = useMemo<string[]>(() => competitors.map((competitor) => competitor.domain.url), [competitors]);
    const label = useMemo<string>(() => {
        const competitorsCount = competitors.length;
        return competitorsCount === 1
            ? translate("llm.campaigns.competitors-indicator.single")
            : translate("llm.campaigns.competitors-indicator.plural", {
                  count: competitorsCount,
              });
    }, [competitors]);

    if (!competitors?.length) {
        return null;
    }

    return (
        <Tooltip content={domainsList.join(", ")}>
            <ChipWrapper data-automation="competitors-indicator">
                <ButtonChipItem
                    text={label}
                    iconName="Install"
                    hideActionButton
                />
            </ChipWrapper>
        </Tooltip>
    );
};
